import type { Step } from 'react-joyride';

import { Step01, Step02 } from './assets';
import { Box } from '@material-ui/core';

import { ContentTour, TitleTour } from '@cobliteam/onboarding';

import { colors } from '@cobliteam/base-components/src/styles/colors';

const commonConfig = {
  spotlightPadding: 10,
  disableBeacon: true,
  styles: {
    spotlight: {
      border: `2px solid ${colors.primary.default}`,
      borderRadius: '10px',
    },
  },
};

const steps: Step[] = [
  {
    ...commonConfig,
    target: '#vehicleTour1',
    placement: 'left-start',
    title: (
      <Box display='flex' gridGap='10px'>
        <Box>
          <img src={Step01} alt='' />
        </Box>
        <TitleTour
          title='Para começar, vamos definir um nome.'
          description='Esse nome será utilizado para buscas, eventos e relatórios. Então sugerimos que você defina um nome que seja fácil de encontrar.'
        />
      </Box>
    ),
    content: <ContentTour />,
  },
  {
    ...commonConfig,
    target: '#vehicleTour2',
    placement: 'left-start',
    title: (
      <div className='flex gap-2.5'>
        <img src={Step02} alt='' className='aspect-auto w-40' />
        <TitleTour
          title='Associe seus veículos aos dispositivos'
          description='É através da Placa que o painel vai saber qual é o veículo associado ao dispositivo que possui o Nº Cobli que você está visualizando.'
        />
      </div>
    ),
    content: <ContentTour />,
  },
  {
    ...commonConfig,
    target: '#vehicleTour3',
    placement: 'left-start',
    title: (
      <TitleTour
        title='Cadastre o odômetro do seu veículo'
        description='Cadastre o odômetro para termos uma estimativa do que é mostrado no odômetro de seu veículo baseado nos quilômetros rodados. Lembrando ser um fator muito importante para manutenção de seu veículo.'
      />
    ),
    content: <ContentTour />,
  },
  {
    ...commonConfig,
    target: '#vehicleTour4',
    placement: 'left-start',
    title: (
      <TitleTour
        title='Saiba como calcular sua estimativa de gasto'
        description='Por aqui, você consegue calcular estimativa de gasto com combustível por trajeto.'
      />
    ),
    content: <ContentTour />,
  },
  {
    ...commonConfig,
    target: '#vehicleTour5',
    placement: 'left-start',
    title: (
      <TitleTour
        title='Defina o limite de velocidade do veículo'
        description='Saiba quando o veículo está acima do limite de velocidade das vias.'
      />
    ),
    content: <ContentTour />,
  },
  // {
  //   ...commonConfig,
  //   target: '#geofenceTour4 > button:nth-child(3)',
  //   placement: 'left-start',
  //   title: (
  //     <TitleTour
  //       title="Desenho: O desenho livre serve para desenhar polígonos."
  //       description="É feito a partir de cliques no mapa, e sempre irá criar um formato fechado. Para iniciar o desenho, clique em um ponto no mapa, e siga clicando em demais pontos até criar o contorno da sua cerca. Finalize o desenho clicando no ponto inicial."
  //     />
  //   ),
  //   content: <ContentTour image={geofencePolygon} imageAlt="Geofence poligonal." />,
  // },
];

export default steps;
